import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home/index.vue";

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index/index.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About/index.vue"),
  },
  {
    path: "/download-app",
    name: "Download",
    component: () => import("@/views/DownLoad/DownLoad.vue"),
  },
];

const getHashScrollTop = (hash) => {
  const element = document.querySelector(hash);

  if (!element) {
    return null;
  }

  const navbar = document.querySelector(".navbar");
  const navbarHeight = navbar?.offsetHeight ?? 80;
  const top = element.getBoundingClientRect().top + window.scrollY - navbarHeight - 12;

  return Math.max(top, 0);
};

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      history.replaceState(history.state, "", " ");
      const top = getHashScrollTop(to.hash);

      if (top !== null) {
        return {
          top,
          behavior: "smooth",
        };
      }

      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    // 默认返回顶部
    return { top: 0 };
  },
  // linkActiveClass: "active",
});

export default router;
